<template>
  <v-row>
    <v-col>
      <ReportHeading
        label="Загальний звіт по роботах"
        :loading="loading"
        @update-report="updateReport"
      >
        <template v-slot:action>
          <DownloadFile
            location="xlsx"
            :params="reportData"
            :filename="
              `Загальний звіт по роботах ${moment(month).format('MM-YYYY')}`
            "
            extension="xlsx"
            tooltip="Завантажити у форматі Excel"
          />
        </template>
        <template v-slot:filters>
          <v-col
            cols="4"
            class="pa-0 pb-3"
          >
            <DateRangePicker
              :start.sync="startDate"
              :end.sync="endDate"
              :filled="false"
              @change="updateReport"
            />
          </v-col>
        </template>
      </ReportHeading>

      <Totals
        :projects-count="projectsCount"
        :spent-hours-total="spentHoursTotal"
      />

      <v-card>
        <SimpleTable
          :headers="headers"
          :loading="loading"
          :items-per-page="filteredItems.length"
          :items="filteredItems"
        />
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import DateRangePicker from "@/components/story/DateRangePicker.vue";
import DownloadFile from "@/components/DowloadFile.vue";
import SimpleTable from "@/components/story/SimpleTable";
import Totals from "./Totals.vue";
import { getWorklogSummary } from "@/backend/reportsApi.js";
import ReportHeading from "@/components/ReportHeading.vue";
import { columnTypes, numberToString } from "@/helpers";

export default {
  components: {
    DownloadFile,
    SimpleTable,
    Totals,
    DateRangePicker,
    ReportHeading,
  },
  data: () => ({
    loading: false,
    items: [],
    headers: [
      { text: "Проект", value: "project", type: "text" },
      {
        text: "Трудозатрати год.",
        value: "spentHours",
        component: "ReportNumber",
      },
    ],
    month: "",
    startDate: "",
    endDate: "",
  }),
  computed: {
    filteredItems() {
      return this.items.map((i) => {
        return {
          project: { ...i.project },
          spentHours: i.spentSeconds / 3600,
        };
      });
    },
    projectsCount() {
      return this.filteredItems?.length || 0;
    },
    spentHoursTotal() {
      return (
        this.filteredItems?.reduce((sum, current) => {
          return sum + current.spentHours;
        }, 0) || 0
      );
    },
    reportData() {
      return {
        columns: ["Проект", "Трудозатрати год."],
        rows: this.filteredItems.map((i) => {
          return [
            i.project.title,
            numberToString(i.spentHours),
          ];
        }),
        columnTypes: [
          columnTypes.STRING,
          columnTypes.NUMBER,
        ],
      };
    },
  },
  created() {
    this.month = this.moment().startOf("month").format("YYYY-MM-DD");
    this.updateReport();
  },
  methods: {
    async updateReport() {
      this.loading = true;
      this.items = [];

      const from = this.moment(this.startDate).format("YYYY-MM-DD");
      const to = this.moment(this.endDate).format("YYYY-MM-DD");

      try {
        const items = await getWorklogSummary(from, to);
        this.items = items.sort((a, b) => {
          const titleA = a.project.title.toUpperCase();
          const titleB = b.project.title.toUpperCase();
          if (titleA < titleB) {
            return -1;
          }
          if (titleA > titleB) {
            return 1;
          }
          return 0;
        });
      } catch {
        this.$notifyWarning("В даних звіту помилки. Подивіться в Система/Стан БД");
      }
      this.loading = false;
    },
  },
};
</script>
